module.exports = "//static.hsappstatic.net/academy-public-ui/static-1.9785/fonts/HubSpotSerif-Book.woff2"